exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Custom {\n  min-height: 400px;\n  font-family: 'Avenir', serif;\n  font-size: 1em;\n  text-align: left;\n  padding: 4em; }\n  .Custom h3 {\n    font-weight: bolder; }\n", ""]);

// exports
